import { Controller } from "@hotwired/stimulus";

// Co-located with Ui::DropdownComponent. Registered as `ui--dropdown`.
export default class extends Controller {
  static targets = ["trigger", "panel"];

  connect() { this.open = false; }

  toggle(event) { this.open ? this.close() : this.openPanel(); }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }

  openPanel() {
    this.open = true;
    this.panelTarget.classList.remove("hidden");
    this.triggerTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    this.open = false;
    this.panelTarget.classList.add("hidden");
    this.triggerTarget.setAttribute("aria-expanded", "false");
  }
}
